import React from 'react';

const HEAL_FLAG = 'norsk_autoheal_v1';

// Чистим кэши и старый service-worker (НЕ трогаем localStorage, чтобы не потерять данные).
function cleanCachesAndSW() {
  const jobs = [];
  try {
    if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
      jobs.push(
        navigator.serviceWorker.getRegistrations()
          .then((regs) => Promise.all(regs.map((r) => r.unregister())))
          .catch(() => {})
      );
    }
  } catch (e) { /* ignore */ }
  try {
    if (window.caches && caches.keys) {
      jobs.push(
        caches.keys()
          .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
          .catch(() => {})
      );
    }
  } catch (e) { /* ignore */ }
  return Promise.all(jobs).catch(() => {});
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, healing: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errMsg: (error && (error.message || String(error))) || "" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('App error boundary:', error, info);
    // Одноразовое самовосстановление: почистить кэш/старый SW и перезагрузиться на свежую версию.
    let canHeal = false;
    try {
      if (sessionStorage.getItem(HEAL_FLAG) !== '1') {
        sessionStorage.setItem(HEAL_FLAG, '1');
        canHeal = true;
      }
    } catch (e) { canHeal = false; }
    if (canHeal) {
      this.setState({ healing: true });
      cleanCachesAndSW().then(() => { window.location.reload(); });
    }
  }

  render() {
    if (this.state.hasError) {
      const wrap = {
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: '16px',
        padding: '24px', fontFamily: 'system-ui, sans-serif',
        textAlign: 'center', color: '#cbbef0', background: '#160f28',
      };
      if (this.state.healing) {
        return (
          <div style={wrap}>
            <div style={{ fontSize: '16px', fontWeight: 600, color: '#f3eefe' }}>
              Обновляем приложение…
            </div>
            <div style={{ fontSize: '14px', maxWidth: '320px' }}>
              Это займёт пару секунд.
            </div>
          </div>
        );
      }
      return (
        <div style={wrap}>
          <div style={{ fontSize: '18px', fontWeight: 700, color: '#f3eefe' }}>
            Не удалось загрузить приложение
          </div>
          <div style={{ fontSize: '14px', maxWidth: '320px' }}>
            Попробуйте перезагрузить страницу.
          </div>
          <div style={{ fontSize: '12px', maxWidth: '340px', color: '#ff9a9a', wordBreak: 'break-word' }}>
            {this.state.errMsg}
          </div>
          <button
            type="button"
            onClick={() => { cleanCachesAndSW().then(() => window.location.reload()); }}
            style={{
              padding: '10px 20px', border: 0, borderRadius: '10px',
              background: '#a78bfa', color: '#fff', fontSize: '15px',
              fontWeight: 600, cursor: 'pointer',
            }}
          >
            Перезагрузить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
